// extracted by mini-css-extract-plugin
export default {"warning-icon":"aUyF","warningIcon":"aUyF","requires-admin-action":"f18Y","requiresAdminAction":"f18Y"};